const YOTPO_APP_KEY = 'Kw7AwvlloU2HcBy8ccYHfwwMPD811gk3iUGmONBW';
const YOTPO_API_BASE = `https://api-cdn.yotpo.com/products/${YOTPO_APP_KEY}`;

const reviewCache = new Map();
const pendingFetches = new Map();
let intersectionObserver = null;

function formatReviewText({ average_score, total_reviews }) {
  if (!total_reviews || total_reviews < 10) return null;
  return `${Number(average_score).toFixed(1)} (${total_reviews})`;
}

function renderReview(element, bottomline) {
  const text = formatReviewText(bottomline);
  if (!text) return;

  element.textContent = text;
  element.removeAttribute('aria-hidden');
}

async function fetchBottomline(productId) {
  if (reviewCache.has(productId)) {
    return reviewCache.get(productId);
  }

  if (pendingFetches.has(productId)) {
    return pendingFetches.get(productId);
  }

  const fetchPromise = fetch(`${YOTPO_API_BASE}/${productId}/bottomline`)
    .then((response) => {
      if (!response.ok) return null;
      return response.json();
    })
    .then((data) => {
      const bottomline = data?.response?.bottomline ?? null;
      reviewCache.set(productId, bottomline);
      return bottomline;
    })
    .catch(() => null)
    .finally(() => {
      pendingFetches.delete(productId);
    });

  pendingFetches.set(productId, fetchPromise);
  return fetchPromise;
}

async function loadReviews(element) {
  const productId = element.dataset.productId;
  if (!productId || element.dataset.loaded) return;

  element.dataset.loaded = 'true';

  const bottomline = await fetchBottomline(productId);
  if (!bottomline) return;

  renderReview(element, bottomline);
}

function getIntersectionObserver() {
  if (intersectionObserver) return intersectionObserver;

  intersectionObserver = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        intersectionObserver.unobserve(entry.target);
        loadReviews(entry.target);
      }
    },
    { rootMargin: '50px' }
  );

  return intersectionObserver;
}

function observeReviews(root = document) {
  const elements = root.querySelectorAll(
    '.product-tile-reviews[data-product-id]:not([data-loaded])'
  );

  if (!elements.length) return;

  const observer = getIntersectionObserver();
  elements.forEach((element) => observer.observe(element));
}

function init() {
  observeReviews();

  const mutationObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;

        if (node.matches?.('.product-tile-reviews[data-product-id]')) {
          observeReviews(node.parentElement ?? document);
        } else if (node.querySelector?.('.product-tile-reviews[data-product-id]')) {
          observeReviews(node);
        }
      }
    }
  });

  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
